import { Spinner } from '@arpeggi/ui'
import { FC } from 'react'
import { RecentEmpty } from '../primitives'

export const RecentLoader: FC = () => (
  <RecentEmpty.Root>
    <Spinner />
  </RecentEmpty.Root>
)
